/**
 * 极简 hash router。10 个视图 key 来自 01-ux-spec.md §2。
 */
export const ROUTE_KEYS = [
  'experience',
  'history',
  'viral',
  'storyboard',
  'video',
  'object',
  'scene',
  'person',
  'assets',
  'settings',
] as const;

export type RouteKey = (typeof ROUTE_KEYS)[number];

const ROUTE_SET = new Set<string>(ROUTE_KEYS);

export const isRouteKey = (k: string): k is RouteKey => ROUTE_SET.has(k);

export function readRouteFromHash(): RouteKey {
  const raw = (window.location.hash || '').replace(/^#/, '');
  return isRouteKey(raw) ? raw : 'experience';
}

export function writeRouteToHash(k: RouteKey): void {
  const target = '#' + k;
  if (window.location.hash !== target) {
    if (history.replaceState) {
      history.replaceState(null, '', target);
    } else {
      window.location.hash = target;
    }
  }
}

export function subscribeHashChange(handler: () => void): () => void {
  window.addEventListener('hashchange', handler);
  return () => window.removeEventListener('hashchange', handler);
}
